<template>
  <router-btn :text="$t('servicesystem.common_objects.job.new')" :icon="'mdi-plus'" :color="'primary'" :disabled="false"
    :outlined="false" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewJobBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      if (this.customerId) {
        this.$router.push({ name: "NewJobOverview", params: {filter: "my"}, query: { customerId: this.customerId, machineId: this.machineId } });
      }
      else {
        this.$router.push({ name: "NewJobStart", params: {filter: "my"},  });
      }
    },
  },

  computed: {
    customerId() {
      if (this.$route.name == 'MachineJobs') {
        var machine = this.$store.getters["entitycontainerstore/getEntity"]('Machine');
        return machine?.CustomerId;
      }
      else {
        return this.$route.params?.customerId || this.$route.query?.customerId;
      }
    },

    machineId(){
      return this.$route.params?.machineId || this.$route.query?.machineId;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
